import Promise from 'promise-polyfill';

export function PublishAddToCartEvent(stockNumber, quantity, pageName) {
  const promise = new Promise((resolve, reject) => {
    try {
      RS.Modules.Analytics.publishAddToCartEvent(stockNumber, quantity, pageName); // eslint-disable-line no-undef
      resolve(true);
    } catch (e) {
      reject(e);
    }
  });
  return promise;
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/Analytics/Analytics.js